<template>
  <div class="account_management">
    <el-form ref="form" :model="query" :rules="rules" label-position="top">
      <el-form-item label="当前账号">
        <el-input disabled v-model="query.account" style="width:300px"></el-input>
      </el-form-item>
      <el-form-item label="绑定手机（绑定之后支持手机号登录）" prop="phone">
        <el-input v-model="query.phone" style="width:300px"></el-input>
      </el-form-item>
      <el-form-item label="用户姓名">
        <el-input v-model="query.name" style="width:300px"></el-input>
      </el-form-item>
      <el-form-item label="输入新密码" prop="pass">
        <el-input show-password v-model="query.pass" @blur="handleBlur" style="width:300px"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPass">
        <el-input show-password v-model="query.confirmPass" style="width:300px"></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" style="width:90px" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getSession,setSession } from "@/utils/storage";
import { updateMember } from "@/api/account-management";
import { message } from "@/common/js/mixins";
export default {
  mixins: [message],
  data() {
    let nameRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("姓名不能为空"));
      }
      callback();
    };
    let phoneRule = (rule, value, callback) => {
      if (value && !/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("手机号格式错误"));
      }
      callback();
    };
    let passRule = (rule, value, callback) => {
      if (value && !/^[\w]{6,16}$/.test(value))
        return callback(new Error("密码格式错误"));
      callback();
    };
    let confirmPassRule = (rule, value, callback) => {
      if (
        (value && !this.query.pass) ||
        (value && this.query.pass && value !== this.query.pass) ||
        (this.query.pass && !value)
      ) {
        return callback(new Error("两次密码输入不一致"));
      }
      callback();
    };
    return {
      query: {
        name: "",
        phone: "",
        account: "",
        pass: "",
        confirmPass: ""
      },
      rules: {
        name: [
          {
            validator: nameRules,
            trigger: "blur"
          }
        ],
        phone: [
          {
            validator: phoneRule,
            trigger: "blur"
          }
        ],
        pass: [
          {
            validator: passRule,
            trigger: "blur"
          }
        ],
        confirmPass: [
          {
            validator: confirmPassRule,
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    // 离开焦点
    handleBlur() {
      if (!this.query.confirmPass && this.query.pass) return;
      this.$refs.form.validateField("confirmPass");
    },
    // 修改保存
    handleSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let obj = {};
          let { phone, name, pass } = this.query;
          if(!pass) obj = {tel:phone,name};
          else obj = {tel:phone,name,pass};
          updateMember({
              ...obj
          })
            .then(res => {
                this.openSuccess('修改成功！');
                Object.assign(this.userInfo,{
                    name,
                    tel:phone
                })
                setSession('userInfo',JSON.stringify(this.userInfo));
                // 同步顶部（懒得用vuex，0.0）
                this.$store.commit('setUserInfo',this.userInfo);
                
            })
            .catch(err => {});
        }
      });
    }
  },
  mounted() {
    this.userInfo = JSON.parse(getSession("userInfo")) || null;
    if (this.userInfo) {
      Object.assign(this.query, {
        account: this.userInfo.account,
        name: this.userInfo.name,
        phone: this.userInfo.tel
      });
    }
  }
};
</script>
<style lang="less" scoped>
.account_management {
  padding-left: 30px;
  /deep/ .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}
</style>